import { type FC } from 'react';

import { type IconProps } from './types';

export const BurgerV4Icon: FC<IconProps> = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="7" y1="13" x2="25" y2="13" stroke="#00FFBB" strokeWidth="2" strokeLinecap="round" />
      <line x1="7" y1="19" x2="25" y2="19" stroke="#00FFBB" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};
